import centerLesion from '@legit-health/svg-images/images/instructions/center-the-lesion.svg';
import noCover from '@legit-health/svg-images/images/instructions/do-not-cover-the-lesion.svg';
import noShadow from '@legit-health/svg-images/images/instructions/no-shadow.svg';
import {TFunction} from 'i18next';
import BaseInstructionsStep from '../../../../steps/InstructionsStep';

export default function Instructions({
  activeStep,
  onBack,
  onNext,
  t,
  totalSteps
}: {
  activeStep: number;
  onBack: () => void;
  onNext: () => void;
  t: TFunction;
  totalSteps: number;
}) {
  const instructions = [
    {
      title: t('shared/common:diagnosticReport.form.instructions.captureLesion.title'),
      description: t('shared/common:diagnosticReport.form.instructions.captureLesion.description'),
      image: centerLesion
    },
    {
      title: t('shared/common:diagnosticReport.form.instructions.avoidShadows.title'),
      description: t('shared/common:diagnosticReport.form.instructions.avoidShadows.description'),
      image: noShadow
    },
    {
      title: t('shared/common:diagnosticReport.form.instructions.dontCover.title'),
      description: t('shared/common:diagnosticReport.form.instructions.dontCover.description'),
      image: noCover
    }
  ];

  return (
    <BaseInstructionsStep
      activeStep={activeStep}
      totalSteps={totalSteps}
      t={t}
      instructions={instructions}
      onNext={onNext}
      onBack={onBack}
    />
  );
}
